import React from "react";
import useIsLandScape from "./useIsLandScape";
import useCheckLogin from "./useCheckLogin";

const useIsLandScapeMachine = () => {
  const isLandScape = useIsLandScape();

  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  return (isMachineDomain || isMachineUser) && !isLandScape;
};

export default useIsLandScapeMachine;
